export const REQUEST_INITIAL_STATE = {
  data: null,
  error: null,
  isFetching: false,
  isFinished: false,
}